import api from './api';

export interface Fund {
	id: string;
	name: string;
	aum: number | string;
	status: string;
	risk_level: string;
	created_at?: string;
}

class FundService {
	async listFunds(limit: number = 50): Promise<Fund[]> {
		const res = await api.get(`/dashboard/top-funds?limit=${limit}`);
		return res.data;
	}
}

export const fundService = new FundService();


